import {Router} from "vue-router";
import {ref} from "vue";

let asideVisible = ref(false);
let router = ref<Router>();

export const LcabLayoutStore = {
    toggleAsideVisible: () => {
        asideVisible.value = !asideVisible.value
    },
    asideVisible,
    router
}